export class TableDataOptionsDto {
  gridName?: string;
  columnWidths?: any;
  columnOrder?: any[];
  shownColumn?: any;
  tableWidth?: any;
}
